'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'envelope-open-text';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f658';
var svgPathData = 'M523.5 125.2c7 4.8 12.4 11.3 16 18.8l-73.3 0-155.4-107.2c-13.7-9.4-31.7-9.4-45.4 0L80.4 164.4 263.8 303.5c2.6 1.9 5.3 3.5 8.2 4.8l0 49.9c-13.2-2.4-26-7.9-37.2-16.4L80 224.3 80 416c0 8.9 7.2 16 16 16l176 0 0 48-176 0c-35.4 0-64-28.7-64-64l0-252c.1-15.5 7.8-30 20.5-38.8L238-2.7c30.1-20.7 69.8-20.7 99.9 0L523.5 125.2zM320 240c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-224zm56 40c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-13.3 0-24 10.7-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeOpenText = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;